module.exports = __webpack_public_path__ + "assets/img/skill.9842762c.svg";